import supabase from "./supabase"

export async function resolveClinicIdentifiers() {
  // 1. Try local cache first (works online and offline)
  try {
    const cachedUuid = localStorage.getItem("tabibi_clinic_id")
    const cachedBigint = localStorage.getItem("tabibi_clinic_id_bigint")
    if (cachedUuid && cachedBigint) {
      const n = Number(cachedBigint)
      if (Number.isFinite(n)) return { clinicUuid: cachedUuid, clinicIdBigint: n }
    }
  } catch {}

  // 2. If offline and no cache, we can't do much (but shouldn't try network)
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    console.warn("[resolveClinicIdentifiers] Offline and no cached clinic identifiers found.");
    return { clinicUuid: null, clinicIdBigint: null };
  }

  // 3. Online path: Fetch from Supabase
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) throw new Error("Not authenticated")

  const { data: prefData, error: prefErr } = await supabase
    .from("user_preferences")
    .select("active_clinic_id")
    .eq("user_id", session.user.id)
    .maybeSingle()

  if (prefErr) throw new Error(prefErr.message || "Failed to load user preferences")

  const { data: userData, error: userErr } = await supabase
    .from("users")
    .select("clinic_id, clinic_id_bigint")
    .eq("user_id", session.user.id)
    .single()

  if (userErr) throw new Error(userErr.message || "Failed to load clinic identifiers")

  const clinicUuid = prefData?.active_clinic_id || userData?.clinic_id
  if (!clinicUuid) throw new Error("User has no clinic assigned")

  let clinicIdBigint = userData?.clinic_id_bigint

  if (!clinicIdBigint) {
    const { data: clinicRow, error: clinicErr } = await supabase
      .from("clinics")
      .select("clinic_id_bigint, id")
      .eq("clinic_uuid", clinicUuid)
      .single()
    if (clinicErr) throw new Error(clinicErr.message || "Failed to load clinic bigint id")
    clinicIdBigint = clinicRow?.clinic_id_bigint || clinicRow?.id || null
  }

  if (!clinicIdBigint) throw new Error("User has no clinic assigned")

  try {
    localStorage.setItem("tabibi_clinic_id", clinicUuid)
    localStorage.setItem("tabibi_clinic_id_bigint", String(clinicIdBigint))
  } catch {}

  return { clinicUuid, clinicIdBigint }
}

export async function resolveClinicUuid() {
  const { clinicUuid } = await resolveClinicIdentifiers()
  return clinicUuid
}

export async function resolveClinicIdBigint() {
  const { clinicIdBigint } = await resolveClinicIdentifiers()
  return clinicIdBigint
}

